import AddEditScheduleModal from './AddEditScheduleModal';

export default AddEditScheduleModal;
